import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faChartBar,faQrcode, faBell, faUser } from '@fortawesome/free-solid-svg-icons';
import colors from '../../config/colors';
import '../../styles/Footer.css';
import { useNotifications } from '../../context/NotificationContext';

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const { unreadCount } = useNotifications();

  const isActive = (path) => location.pathname === path;

  const handleQRScan = () => {
    navigate('/qr-scanner');
  };

  return (
    <footer className="footer" style={{ backgroundColor: colors.primary }}>
      <button 
        onClick={() => navigate('/dashboard')} 
        className={`footer-button ${isActive('/dashboard') ? 'active' : ''}`}
      >
        <FontAwesomeIcon icon={faHome} />
        <span>Trang chủ</span>
      </button>
      <button 
        onClick={() => navigate('/profile')}
        className={`footer-button ${isActive('/profile') ? 'active' : ''}`}
      >
        <FontAwesomeIcon icon={faUser} />
        <span>Tài khoản</span>
      </button>
      
      <button 
        className="footer-button qr-button"
        onClick={handleQRScan}
      >
        <FontAwesomeIcon icon={faQrcode} />
      </button>

      <button 
        onClick={() => navigate('/notifications')} 
        className={`footer-button ${isActive('/notifications') ? 'active' : ''}`}
      >
        <div className="icon-badge-container">
          <FontAwesomeIcon icon={faBell} />
          {unreadCount > 0 && <span className="notification-dot"></span>}
        </div>
        <span>Thông báo</span>
      </button>
      <button 
        onClick={() => navigate('/ticket-statistics')} 
        className={`footer-button ${isActive('/ticket-statistics') ? 'active' : ''}`}
      >
        <FontAwesomeIcon icon={faChartBar} />
        <span>Báo cáo</span>
      </button>
    </footer>
  );
}

export default Footer;
